<template>
  <v-card 
    outlined
    color="transparent"
    class="alerts text-left mx-n4 my-4"
  >
    <v-card-title
      class="text-h6 font-weight-bold primary--text"
      v-html="formatText($t('referrals.cta.title'))"
    />
    <v-card-text>
      <p 
        class="text-body-1 white--text"
        v-html="formatText($t('referrals.cta.text'))"
      />
      <i18n 
        v-show="bonus"
        path="referrals.cta.bonus.text"
        tag="p"
        class="text-body-1 white--text my-4"
      >
        <a @click="help(true, 'signup', 'signup', 4)">{{ $t('referrals.cta.bonus.link') }}</a>.
      </i18n>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        block
        class="black--text"
        @click="copyReferralURL(user)"
      >
        {{ $t('referrals.cta.button') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss">
</style>

<script>

import services from '@/services.js'
import { sync, get } from 'vuex-pathify'

export default {
  name: 'ReferralCard',
  props: {
    user: {
      type: Object,
      default: () => null
    },
    bonus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    toast: sync('app/toast'),
  },
  methods: {
    ...services,

    help (toggle, page, section, item) {
      this.$emit('help', toggle, page, section, item)
    },
  }
};

</script>